export class User {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  image: string;
  createdAt: string;
  birthday: string;
  birthdayDate: string;

  constructor (id: number, name: string, email: string, image: string, createdAt: string, birthday: string, firstName = '', lastName = '', birthdayDate = '') {
    this.id = id
    this.name = name
    this.email = email
    this.image = image
    this.createdAt = createdAt
    this.birthday = birthday
    this.firstName = firstName
    this.lastName = lastName
    this.birthdayDate = birthdayDate
  }

  static fromAPI (entry: Record<string, any>): User {
    return new User(
      entry.id,
      entry.name,
      entry.email,
      entry.image,
      entry.created_at,
      entry.birthday,
      entry.first_name ?? '',
      entry.last_name ?? '',
      entry.birthday_date ?? ''
    )
  }
}
